import { useState, useEffect, useRef } from "react";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import { HexColorPicker } from "react-colorful";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Edit from "@mui/icons-material/Edit";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import ReactSelect from "react-select";
import appConfig from "../../../config";

function ChatbotConfig({ config, token, onSave, onConfigChange, chatbotID }) {
  const [name, setName] = useState("");
  const [welcomeMessage, setWelcomeMessage] = useState("");
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [headerColor, setHeaderColor] = useState("#3B82F6");
  const [buttonColor, setButtonColor] = useState("#3B82F6");
  const [textColor, setTextColor] = useState("#1F2937");
  const [backgroundColor, setBackgroundColor] = useState("#F9FAFB");
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [modelForAnswer, setModelForAnswer] = useState(
    "meta-llama/llama-4-maverick-17b-128e-instruct"
  );
  const [modelForIntent, setModelForIntent] = useState(
    "meta-llama/llama-4-maverick-17b-128e-instruct"
  );
  const [modelForFollowup, setModelForFollowup] = useState(
    "meta-llama/llama-4-maverick-17b-128e-instruct"
  );
  const [intents, setIntents] = useState([]);
  const [intentDialogOpen, setIntentDialogOpen] = useState(false);
  const [editingIntentIndex, setEditingIntentIndex] = useState(null);
  const [intentName, setIntentName] = useState("");
  const [intentDescription, setIntentDescription] = useState("");
  const [intentResponse, setIntentResponse] = useState("");
  const [intentKnowledgeType, setIntentKnowledgeType] = useState("");
  const [colorPicker, setColorPicker] = useState({
    open: false,
    value: "#000000",
    setter: () => {},
    title: "Vyber farbu",
  });
  const [webUrl, setWebUrl] = useState("");
  const [knowledgeType, setKnowledgeType] = useState("contacts");
  const [webPath, setWebPath] = useState("/kontakty");
  const [ingestResult, setIngestResult] = useState(null);
  const [ingestLoading, setIngestLoading] = useState(false);
  const [ingestTaskId, setIngestTaskId] = useState(null);
  const [ingestPolling, setIngestPolling] = useState(false);
  const [intentQueryRefinement, setIntentQueryRefinement] = useState("");
  const [collections, setCollections] = useState([]);
  const [collectionsLoading, setCollectionsLoading] = useState(false);
  const [knowledgeDialogOpen, setKnowledgeDialogOpen] = useState(false);
  const [newKnowledgeType, setNewKnowledgeType] = useState("contacts");
  const [newWebUrl, setNewWebUrl] = useState("");
  const [newWebPath, setNewWebPath] = useState("/kontakty");
  const [newIngestLoading, setNewIngestLoading] = useState(false);
  const [newIngestResult, setNewIngestResult] = useState(null);
  const [language, setLanguage] = useState("en");

  // Nové stavy pre produkty
  const [intentTopProducts, setIntentTopProducts] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [productSearchLoading, setProductSearchLoading] = useState(false);
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const avatarInputRef = useRef(null);

  const languageOptions = [
    { value: "en", label: "English" },
    { value: "sk", label: "Slovenčina" },
    { value: "cs", label: "Čeština" },
    { value: "hu", label: "Magyar" },
    { value: "pl", label: "Polski" },
    { value: "uk", label: "Українська" },
    { value: "de", label: "Deutsch" },
    { value: "nl", label: "Nederlands" },
  ];

  const groupedModelOptions = [
    {
      label: "💎 Premium Models (OpenAI)",
      options: [{ value: "gpt-4o", label: "gpt-4o" }],
    },
    {
      label: "💎 Premium Models (Cohere)",
      options: [
        { value: "command-r-plus", label: "command-r-plus" },
        { value: "command-r", label: "command-r" },
        { value: "command-light", label: "command-light" },
      ],
    },
    {
      label: "🎯 Prirodzené odpovede ale môže si vymýšľať slová",
      options: [
        {
          value: "llama-3.3-70b-versatile",
          label: "llama-3.3-70b-versatile",
        },
        {
          value: "meta-llama/llama-4-maverick-17b-128e-instruct",
          label: "meta-llama/llama-4-maverick-17b-128e-instruct",
        },
        {
          value: "llama-3.1-8b-instant",
          label: "llama-3.1-8b-instant",
        },
        {
          value: "gemma2-9b-it",
          label: "gemma2-9b-it",
        },
        {
          value: "meta-llama/llama-guard-4-12b",
          label: "meta-llama/llama-guard-4-12b",
        },
      ],
    },
    {
      label: "🧠 Modely ukazujúce premýšľanie chatbota (think tag)",
      options: [
        {
          value: "deepseek-r1-distill-llama-70b",
          label: "deepseek-r1-distill-llama-70b",
        },
        {
          value: "qwen/qwen3-32b",
          label: "qwen/qwen3-32b",
        },
      ],
    },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "45px",
      borderColor: state.isFocused ? "#5a49da" : "rgba(0, 0, 0, 0.23)",
      boxShadow: state.isFocused ? "0 0 0 1px #5a49da" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#5a49da" : "rgba(0, 0, 0, 0.87)",
      },
      marginBottom: "24px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(0, 0, 0, 0.6)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#5a49da"
        : state.isFocused
        ? "rgba(90, 73, 218, 0.1)"
        : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: state.isSelected ? "#5a49da" : "rgba(90, 73, 218, 0.1)",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 10,
    }),
  };

  const formatOptionLabel = (option) => <div>{option.label}</div>;

  useEffect(() => {
    if (config) {
      setName(config.name || "");
      setWelcomeMessage(
        config.welcomeMessage || config.systemInstructions || "Hello! How can I help you today?"
      );
      setSuggestedQuestions(config.suggestedQuestions || []);
      setHeaderColor(config.headerColor || "#3B82F6");
      setButtonColor(config.buttonColor || "#3B82F6");
      setTextColor(config.textColor || "#1F2937");
      setBackgroundColor(config.backgroundColor || "#F9FAFB");
      setIntents(config.intents || []);
      setAvatarUrl(config.avatar_url || null);
      setLanguage(config.language || "en");

      // Pri načítaní existujúcej konfigurácie, prepíšeme predvolené hodnoty
      // Ak kľúče neexistujú (napr. nový chatbot), predvolené hodnoty zo `useState` zostanú
      if (config.model_answer !== undefined || config.model !== undefined) {
        setModelForAnswer(config.model_answer || config.model || "");
      }
      if (config.model_intent !== undefined) {
        setModelForIntent(config.model_intent || "");
      }
      if (config.model_followup !== undefined) {
        setModelForFollowup(config.model_followup || "");
      }
    }
  }, [config]);

  // Posielam náhľad konfigurácie nahor pri každej zmene relevantných polí
  useEffect(() => {
    if (typeof onConfigChange === "function") {
      onConfigChange({
        name,
        welcomeMessage,
        suggestedQuestions,
        headerColor,
        buttonColor,
        textColor,
        backgroundColor,
        intents,
        avatar_url: avatarUrl,
        model_answer: modelForAnswer,
        model_intent: modelForIntent,
        model_followup: modelForFollowup,
        language,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    name,
    welcomeMessage,
    suggestedQuestions,
    headerColor,
    buttonColor,
    textColor,
    backgroundColor,
    intents,
    avatarUrl,
    modelForAnswer,
    modelForIntent,
    modelForFollowup,
    language,
  ]);

  useEffect(() => {
    if (knowledgeType === "contacts") setWebPath("/kontakty");
    else if (knowledgeType === "news") setWebPath("/rss.rss");
    else if (knowledgeType === "waste") setWebPath("/zvoz-odpadu.rss");
    else if (knowledgeType === "xml") setWebPath("");
  }, [knowledgeType]);

  useEffect(() => {
    const fetchCollections = async () => {
      if (!chatbotID) return;
      setCollectionsLoading(true);
      try {
        const userToken = localStorage.getItem("token");
        if (!userToken) {
          console.error("User not authenticated for fetching collections.");
          return;
        }
        const resp = await fetch(
          `${appConfig.BASE_URL}/api/chatbots/${chatbotID}/qdrant-collections`,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );
        const data = await resp.json();
        setCollections(data.collections || []);
      } catch (e) {
        setCollections([]);
      }
      setCollectionsLoading(false);
    };
    fetchCollections();
  }, [chatbotID]);

  // Funkcia na vyhľadávanie produktov
  const searchProducts = async (searchTerm) => {
    if (!chatbotID || !searchTerm.trim()) {
      setProductOptions([]);
      return;
    }

    setProductSearchLoading(true);
    try {
      const userToken = localStorage.getItem("token");
      if (!userToken) {
        console.error("User not authenticated for product search.");
        return;
      }
      const response = await fetch(
        `/v1/chatbots/${chatbotID}/products?query=${encodeURIComponent(searchTerm)}&limit=20`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      const data = await response.json();
      setProductOptions(data.products || []);
    } catch (error) {
      console.error("Chyba pri vyhľadávaní produktov:", error);
      setProductOptions([]);
    }
    setProductSearchLoading(false);
  };

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (productSearchTerm) {
        searchProducts(productSearchTerm);
      } else {
        setProductOptions([]);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [productSearchTerm, chatbotID]);

  const handleAvatarUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const userToken = localStorage.getItem("token");
    if (!userToken) {
      console.error("User not authenticated for avatar upload.");
      // Tu by sa zišiel snackbar, ale pre jednoduchosť len logujeme
      return;
    }

    const formData = new FormData();
    formData.append("avatar", file);

    try {
      const response = await fetch(`${appConfig.BASE_URL}/api/chatbots/${chatbotID}/avatar`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to upload avatar");
      }

      const data = await response.json();
      setAvatarUrl(data.avatar_url);
    } catch (error) {
      console.error("Error uploading avatar:", error);
    }
  };

  const handleIntentSave = () => {
    const newIntent = {};
    if (intentName) newIntent.name = intentName;
    if (intentDescription) newIntent.description = intentDescription;
    if (intentResponse) newIntent.response = intentResponse;
    if (intentKnowledgeType) newIntent.knowledge_type = intentKnowledgeType;
    if (intentQueryRefinement) newIntent.query_refinement = intentQueryRefinement;
    if (intentTopProducts.length > 0) newIntent.top_products = intentTopProducts;

    let newIntents = [...intents];
    if (editingIntentIndex !== null) {
      newIntents[editingIntentIndex] = newIntent;
    } else {
      newIntents.push(newIntent);
    }
    setIntents(newIntents);
    setIntentDialogOpen(false);
    setEditingIntentIndex(null);
    setIntentName("");
    setIntentDescription("");
    setIntentResponse("");
    setIntentKnowledgeType("");
    setIntentQueryRefinement("");
    setIntentTopProducts([]);
  };

  const handleIntentEdit = (idx) => {
    const intent = intents[idx];
    setIntentName(intent.name || "");
    setIntentDescription(intent.description || "");
    setIntentResponse(intent.response || "");
    setIntentKnowledgeType(intent.knowledge_type || "");
    setIntentQueryRefinement(intent.query_refinement || "");
    setIntentTopProducts(intent.top_products || []);
    setEditingIntentIndex(idx);
    setIntentDialogOpen(true);
  };

  const handleIntentAdd = () => {
    setIntentName("");
    setIntentDescription("");
    setIntentResponse("");
    setIntentKnowledgeType("");
    setIntentQueryRefinement("");
    setIntentTopProducts([]);
    setEditingIntentIndex(null);
    setIntentDialogOpen(true);
  };

  const handleIntentDelete = (idx) => {
    const newIntents = intents.filter((_, i) => i !== idx);
    setIntents(newIntents);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const cleanedIntents = intents.map((intent) => {
      const cleaned = {};
      if (intent.name) cleaned.name = intent.name;
      if (intent.description) cleaned.description = intent.description;
      if (intent.response) cleaned.response = intent.response;
      if (intent.knowledge_type) cleaned.knowledge_type = intent.knowledge_type;
      if (intent.query_refinement) cleaned.query_refinement = intent.query_refinement;
      if (intent.top_products && intent.top_products.length > 0)
        cleaned.top_products = intent.top_products;
      return cleaned;
    });
    onSave({
      name,
      welcomeMessage,
      suggestedQuestions,
      headerColor,
      buttonColor,
      textColor,
      backgroundColor,
      intents: cleanedIntents,
      model_answer: modelForAnswer,
      model_intent: modelForIntent,
      model_followup: modelForFollowup,
      language,
    });
  };

  useEffect(() => {
    let interval;
    if (ingestPolling && ingestTaskId) {
      interval = setInterval(async () => {
        try {
          const resp = await fetch(`${appConfig.BASE_URL}/v1/rss-ingest-status/${ingestTaskId}`);
          const data = await resp.json();
          if (data.status === "success" || data.status === "error") {
            setIngestResult(data);
            setIngestPolling(false);
            setIngestTaskId(null);
          }
        } catch (e) {
          setIngestResult({ status: "error", error: e.message });
          setIngestPolling(false);
          setIngestTaskId(null);
        }
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [ingestPolling, ingestTaskId]);

  const handleKnowledgeAdd = () => {
    setNewKnowledgeType("contacts");
    setNewWebUrl("");
    setNewWebPath("/kontakty");
    setNewIngestResult(null);
    setKnowledgeDialogOpen(true);
  };

  const handleKnowledgeIngest = async () => {
    setNewIngestLoading(true);
    setNewIngestResult(null);
    try {
      const chatbotToken = token || config?.token || "";
      const url = newWebUrl.endsWith("/") ? newWebUrl.slice(0, -1) : newWebUrl;
      const fullUrl = url + newWebPath;
      const body = {
        rss_url: fullUrl,
        chatbot_id: chatbotToken,
        knowledge_type: newKnowledgeType,
      };
      const resp = await fetch("/v1/rss-ingest", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await resp.json();
      if (data.status === "success") {
        setCollections((prev) => {
          let found = false;
          const updated = prev.map((col) => {
            if (col.name === newKnowledgeType) {
              found = true;
              return {
                ...col,
                knowledge_types: Array.from(
                  new Set([...(col.knowledge_types || []), newKnowledgeType])
                ),
              };
            }
            return col;
          });
          if (!found) {
            updated.push({ name: newKnowledgeType, knowledge_types: [newKnowledgeType] });
          }
          return updated;
        });
      }
      setNewIngestResult(data);
    } catch (e) {
      setNewIngestResult({ status: "error", error: e.message });
    }
    setNewIngestLoading(false);
  };

  const handleKnowledgeDelete = async (collectionName, type) => {
    try {
      const res = await fetch(
        `${appConfig.BASE_URL}/api/chatbots/${chatbotID}/qdrant-collections/${collectionName}/knowledge-types/${type}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );

      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          alert("Chyba: Nie ste prihlásený alebo nemáte oprávnenie.");
        } else {
          const errData = await res.json();
          throw new Error(errData.message || "Chyba pri mazaní znalostného typu.");
        }
        return;
      }

      setCollections((prev) =>
        prev
          .map((col) => ({
            ...col,
            knowledge_types: (col.knowledge_types || []).filter((t) => t !== type),
          }))
          .filter((col) => (col.knowledge_types || []).length > 0)
      );
    } catch (err) {
      alert(err.message);
    }
  };

  const handleAddProduct = (product) => {
    if (product && !intentTopProducts.find((p) => p.product_name === product.product_name)) {
      setIntentTopProducts([...intentTopProducts, product]);
    }
    setProductSearchTerm("");
    setProductOptions([]);
  };

  const handleRemoveProduct = (productToRemove) => {
    setIntentTopProducts(
      intentTopProducts.filter((p) => p.product_name !== productToRemove.product_name)
    );
  };

  const openColorDialog = (title, value, setter) => {
    setColorPicker({ open: true, title, value, setter });
  };

  const handleColorChange = (newValue) => {
    setColorPicker({ ...colorPicker, value: newValue });
  };

  const handleColorConfirm = () => {
    colorPicker.setter(colorPicker.value);
    setColorPicker({ ...colorPicker, open: false });
  };

  const ColorInputField = ({ label, color, setColor }) => (
    <div style={{ position: "relative" }}>
      <TextField
        type="text"
        label={label}
        value={color}
        onChange={(e) => setColor(e.target.value)}
        fullWidth
        variant="outlined"
      />
      <IconButton
        onClick={() => openColorDialog(`Vyber farbu - ${label}`, color, setColor)}
        sx={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          p: 0.5,
        }}
      >
        <span
          style={{
            width: 24,
            height: 24,
            borderRadius: "4px",
            background: color,
            border: "1px solid #ccc",
            display: "inline-block",
          }}
        />
      </IconButton>
    </div>
  );

  ColorInputField.propTypes = {
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    setColor: PropTypes.func.isRequired,
  };

  const handleAddQuestion = () => {
    if (currentQuestion.trim() && !suggestedQuestions.includes(currentQuestion.trim())) {
      setSuggestedQuestions([...suggestedQuestions, currentQuestion.trim()]);
      setCurrentQuestion("");
    }
  };

  const handleRemoveQuestion = (index) => {
    setSuggestedQuestions(suggestedQuestions.filter((_, i) => i !== index));
  };

  return (
    <MDBox component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
      <Card sx={{ mb: 3, borderLeft: "4px solid", borderColor: "info.main" }}>
        <MDBox p={3}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <SettingsOutlinedIcon color="info" sx={{ mr: 1 }} />
            <MDTypography variant="h6" fontWeight="medium">
              Basic Settings
            </MDTypography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Avatar src={avatarUrl} sx={{ width: 80, height: 80, mr: 2 }} />
            <Box>
              <MDButton
                variant="outlined"
                color="info"
                onClick={() => avatarInputRef.current && avatarInputRef.current.click()}
              >
                Upload Avatar
              </MDButton>
              <input
                type="file"
                ref={avatarInputRef}
                onChange={handleAvatarUpload}
                accept="image/*"
                hidden
              />
              <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 1 }}>
                Allowed *.jpeg, *.jpg, *.png, *.gif. Max size of 3.1 MB.
              </MDTypography>
            </Box>
          </Box>
          <MDBox mb={2}>
            <TextField
              type="text"
              label="Chatbot Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              variant="outlined"
            />
          </MDBox>
          <TextField
            label="Welcome message"
            multiline
            rows={4}
            value={welcomeMessage}
            onChange={(e) => setWelcomeMessage(e.target.value)}
            fullWidth
            variant="outlined"
          />
          <MDBox mt={2}>
            <MDTypography variant="subtitle1" fontWeight="medium" mb={1}>
              Suggested Questions
            </MDTypography>
            <MDBox display="flex" mb={1}>
              <TextField
                label="Add a question"
                value={currentQuestion}
                onChange={(e) => setCurrentQuestion(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddQuestion();
                  }
                }}
                fullWidth
                variant="outlined"
              />
              <MDButton
                onClick={handleAddQuestion}
                variant="gradient"
                color="info"
                sx={{ ml: 1, flexShrink: 0 }}
              >
                Add
              </MDButton>
            </MDBox>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              {suggestedQuestions.map((q, index) => (
                <Chip key={index} label={q} onDelete={() => handleRemoveQuestion(index)} />
              ))}
            </Stack>
          </MDBox>
        </MDBox>
      </Card>

      <Card sx={{ mb: 3, borderLeft: "4px solid", borderColor: "warning.main" }}>
        <MDBox p={3}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PaletteOutlinedIcon color="warning" sx={{ mr: 1 }} />
            <MDTypography variant="h6" fontWeight="medium">
              Appearance Settings
            </MDTypography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <ColorInputField label="Header Color" color={headerColor} setColor={setHeaderColor} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ColorInputField label="Button Color" color={buttonColor} setColor={setButtonColor} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ColorInputField label="Text Color" color={textColor} setColor={setTextColor} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ColorInputField
                label="Background Color"
                color={backgroundColor}
                setColor={setBackgroundColor}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Card>
      <Dialog
        open={colorPicker.open}
        onClose={() => setColorPicker({ ...colorPicker, open: false })}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: 300,
          }}
        >
          <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 16 }}>{colorPicker.title}</div>
          <HexColorPicker
            color={colorPicker.value}
            onChange={handleColorChange}
            style={{ width: 220, height: 120 }}
          />
          <div style={{ display: "flex", alignItems: "center", marginTop: 16 }}>
            <span
              style={{
                display: "inline-block",
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: colorPicker.value,
                border: "1px solid #ccc",
                marginRight: 12,
              }}
            />
            <span style={{ fontFamily: "monospace", fontSize: 16 }}>{colorPicker.value}</span>
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
          <MDButton onClick={() => setColorPicker({ ...colorPicker, open: false })} color="info">
            Zrušiť
          </MDButton>
          <MDButton onClick={handleColorConfirm} color="info" variant="gradient">
            Potvrdiť
          </MDButton>
        </DialogActions>
      </Dialog>
      <Card sx={{ mb: 3, borderLeft: "4px solid", borderColor: "primary.main" }}>
        <MDBox p={3}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <PsychologyOutlinedIcon color="primary" sx={{ mr: 1 }} />
              <MDTypography variant="h6" fontWeight="medium">
                Intents
              </MDTypography>
            </Box>
            <MDButton
              variant="gradient"
              color="info"
              size="small"
              startIcon={<AddIcon />}
              onClick={handleIntentAdd}
            >
              Add Intent
            </MDButton>
          </MDBox>
          <List>
            {intents.map((intent, idx) => (
              <ListItem
                key={intent.name + idx}
                secondaryAction={
                  <MDBox mr={1}>
                    <Stack direction="row" spacing={1}>
                      <MDButton
                        variant="outlined"
                        color="info"
                        iconOnly
                        onClick={() => handleIntentEdit(idx)}
                      >
                        <Edit />
                      </MDButton>
                      <MDButton
                        variant="outlined"
                        color="error"
                        iconOnly
                        onClick={() => handleIntentDelete(idx)}
                      >
                        <DeleteIcon />
                      </MDButton>
                    </Stack>
                  </MDBox>
                }
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                  mb: 1,
                  px: 2,
                  py: 1.5,
                }}
              >
                <ListItemText
                  primary={
                    <Box display="flex" alignItems="center">
                      <span style={{ fontWeight: 500 }}>{intent.name}</span>
                      {intent.knowledge_type ? (
                        <Chip label="Knowledge Base" size="small" sx={{ ml: 1 }} />
                      ) : (
                        <Chip label="Custom Response" size="small" sx={{ ml: 1 }} />
                      )}
                    </Box>
                  }
                  secondary={intent.description}
                />
              </ListItem>
            ))}
          </List>
        </MDBox>
      </Card>
      <Dialog open={intentDialogOpen} onClose={() => setIntentDialogOpen(false)}>
        <DialogTitle>{editingIntentIndex !== null ? "Upraviť zámer" : "Pridať zámer"}</DialogTitle>
        <DialogContent>
          <TextField
            type="text"
            label="Názov zámeru"
            placeholder="napr. Pozdrav, Info o produkte"
            value={intentName}
            onChange={(e) => setIntentName(e.target.value)}
            fullWidth
            variant="standard"
            InputProps={{ sx: { borderRadius: 1, py: 1 } }}
            sx={{ mb: 2 }}
          />
          <TextField
            type="text"
            label="Kedy použiť"
            placeholder="napr. Keď sa používateľ pýta na zvoz odpadu"
            value={intentDescription}
            onChange={(e) => setIntentDescription(e.target.value)}
            fullWidth
            multiline
            rows={2}
            variant="standard"
            InputProps={{ sx: { borderRadius: 1, py: 1 } }}
            sx={{ mb: 2 }}
          />
          <FormControl component="fieldset" sx={{ mb: 2 }}>
            <MDTypography variant="subtitle2" sx={{ mb: 1 }}>
              Konfigurácia odpovede
            </MDTypography>
            <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={intentKnowledgeType === ""}
                    onChange={() => setIntentKnowledgeType("")}
                  />
                }
                label="Vlastná odpoveď"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={intentKnowledgeType !== ""}
                    onChange={() => setIntentKnowledgeType("contacts")}
                  />
                }
                label="Prepojenie na znalostnú kolekciu"
              />
            </Stack>
          </FormControl>
          {intentKnowledgeType === "" ? (
            <TextField
              type="text"
              label="Vlastná odpoveď"
              placeholder="Sem napíš odpoveď, ktorú má chatbot použiť..."
              value={intentResponse}
              onChange={(e) => setIntentResponse(e.target.value)}
              fullWidth
              multiline
              rows={3}
              variant="standard"
              InputProps={{ sx: { borderRadius: 1, py: 1 } }}
              sx={{ mb: 2 }}
            />
          ) : (
            <>
              <TextField
                select
                label="Vyber kolekciu znalostí"
                value={intentKnowledgeType}
                onChange={(e) => setIntentKnowledgeType(e.target.value)}
                fullWidth
                variant="standard"
                InputProps={{ sx: { borderRadius: 1, py: 1 } }}
                sx={{ mb: 2 }}
              >
                <MenuItem value="contacts">Kontakty</MenuItem>
                <MenuItem value="waste">Odpad</MenuItem>
                <MenuItem value="news">Novinky</MenuItem>
                <MenuItem value="xml">Produkty (XML)</MenuItem>
                <MenuItem value="what_is_new">Posledné novinky</MenuItem>
                <MenuItem value="how_to">Ako vybaviť</MenuItem>
                <MenuItem value="faq">FAQ</MenuItem>
              </TextField>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 16,
                }}
              >
                <MDTypography variant="subtitle2" sx={{ mb: 0 }}>
                  Query refinement (voliteľné)
                </MDTypography>
                <Tooltip
                  title={
                    "Inštrukcia pre LLM ako preformulovať otázku na vyhľadávací dotaz, napr. 'Preformuluj otázku na názov produktu, oprav preklepy, použij správny názov.'"
                  }
                  placement="left"
                >
                  <HelpOutlineIcon color="action" style={{ cursor: "pointer", marginLeft: 8 }} />
                </Tooltip>
              </div>
              <TextField
                type="text"
                value={intentQueryRefinement}
                onChange={(e) => {
                  if (e.target.value.length <= 500) setIntentQueryRefinement(e.target.value);
                }}
                fullWidth
                multiline
                rows={4}
                variant="standard"
                InputProps={{ sx: { borderRadius: 1, py: 1 } }}
                sx={{ mb: 1 }}
                placeholder={
                  "Inštrukcia pre LLM ako preformulovať otázku na vyhľadávací dotaz, napr. 'Preformuluj otázku na názov produktu, oprav preklepy, použij správny názov.'"
                }
                inputProps={{ maxLength: 500 }}
              />
              <div
                style={{
                  textAlign: "right",
                  fontSize: 12,
                  color: "#888",
                  marginBottom: 16,
                }}
              >
                {intentQueryRefinement.length}/500 znakov
              </div>
              {/* Top produkty section - len pre XML intent */}
              {intentKnowledgeType === "xml" && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 16,
                    }}
                  >
                    <MDTypography variant="subtitle2" sx={{ mb: 0 }}>
                      Top produkty (voliteľné)
                    </MDTypography>
                    <Tooltip
                      title={
                        "Vyber najdôležitejšie produkty pre tento zámer. Pomôže to LLM lepšie pochopiť kontext a generovať presnejšie vyhľadávacie dotazy."
                      }
                      placement="left"
                    >
                      <HelpOutlineIcon
                        color="action"
                        style={{ cursor: "pointer", marginLeft: 8 }}
                      />
                    </Tooltip>
                  </div>

                  {/* Autocomplete pre vyhľadávanie produktov */}
                  <Autocomplete
                    options={productOptions}
                    getOptionLabel={(option) => option.product_name || ""}
                    loading={productSearchLoading}
                    inputValue={productSearchTerm}
                    onInputChange={(event, newInputValue) => {
                      setProductSearchTerm(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        handleAddProduct(newValue);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Vyhľadaj produkty"
                        variant="standard"
                        sx={{ mb: 2 }}
                        placeholder="Napr. LED, ziarovka, chranic..."
                        InputProps={{
                          ...params.InputProps,
                          sx: { borderRadius: 1, py: 1 },
                          endAdornment: (
                            <>
                              {productSearchLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      <li {...props}>
                        <div>
                          <div style={{ fontWeight: 500, fontSize: 14 }}>{option.product_name}</div>
                          {option.price && (
                            <div style={{ fontSize: 12, color: "#666" }}>{option.price} EUR</div>
                          )}
                        </div>
                      </li>
                    )}
                    noOptionsText="Žiadne produkty nenájdené"
                    loadingText="Vyhľadávam..."
                  />

                  {/* Chips pre vybrané produkty */}
                  {intentTopProducts.length > 0 && (
                    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2, rowGap: 1 }}>
                      {intentTopProducts.map((product, idx) => (
                        <Chip
                          key={idx}
                          label={
                            <div style={{ maxWidth: 250 }}>
                              <div style={{ fontWeight: 500, fontSize: 12 }}>
                                {product.product_name.length > 40
                                  ? product.product_name.substring(0, 40) + "..."
                                  : product.product_name}
                              </div>
                              {product.price && (
                                <div style={{ fontSize: 10, opacity: 0.8 }}>
                                  {product.price} EUR
                                </div>
                              )}
                            </div>
                          }
                          onDelete={() => handleRemoveProduct(product)}
                          color="primary"
                          variant="outlined"
                          size="small"
                        />
                      ))}
                    </Stack>
                  )}

                  {intentTopProducts.length > 0 && (
                    <div
                      style={{
                        textAlign: "right",
                        fontSize: 12,
                        color: "#666",
                        marginBottom: 16,
                      }}
                    >
                      Vybraných {intentTopProducts.length} produktov
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setIntentDialogOpen(false)} color="info">
            Zrušiť
          </MDButton>
          <MDButton onClick={handleIntentSave} color="info">
            Uložiť
          </MDButton>
        </DialogActions>
      </Dialog>
      <Card sx={{ borderLeft: "4px solid", borderColor: "success.main" }}>
        <MDBox p={3}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <DnsOutlinedIcon color="success" sx={{ mr: 1 }} />
              <MDTypography variant="h6" fontWeight="medium">
                Knowledge Base
              </MDTypography>
            </Box>
            <MDButton
              variant="gradient"
              color="info"
              size="small"
              startIcon={<AddIcon />}
              onClick={handleKnowledgeAdd}
            >
              Add Collection
            </MDButton>
          </MDBox>
          <List sx={{ mb: 2 }}>
            {Array.isArray(collections) &&
              collections.length > 0 &&
              collections.flatMap((col) =>
                (col.knowledge_types || []).map((type) => (
                  <ListItem
                    key={type}
                    secondaryAction={
                      <MDBox mr={1}>
                        <MDButton
                          variant="outlined"
                          color="error"
                          iconOnly
                          onClick={() => handleKnowledgeDelete(col.name, type)}
                        >
                          <DeleteIcon />
                        </MDButton>
                      </MDBox>
                    }
                    sx={{ border: "1px solid #e0e0e0", borderRadius: 1, mb: 1, px: 2, py: 1.5 }}
                  >
                    <ListItemText primary={type} />
                  </ListItem>
                ))
              )}
          </List>
        </MDBox>
      </Card>
      <Dialog open={knowledgeDialogOpen} onClose={() => setKnowledgeDialogOpen(false)}>
        <DialogTitle>Pridať kolekciu</DialogTitle>
        <DialogContent>
          <TextField
            select
            label="Typ znalosti"
            value={newKnowledgeType}
            onChange={(e) => {
              setNewKnowledgeType(e.target.value);
              if (e.target.value === "contacts") setNewWebPath("/kontakty");
              else if (e.target.value === "news") setNewWebPath("/rss.rss");
              else if (e.target.value === "waste") setNewWebPath("/zvoz-odpadu.rss");
              else if (e.target.value === "xml") setNewWebPath("");
            }}
            fullWidth
            variant="standard"
            InputProps={{ sx: { borderRadius: 1, py: 1 } }}
            sx={{ mb: 2 }}
          >
            <MenuItem value="contacts">Kontakty</MenuItem>
            <MenuItem value="waste">Odpad</MenuItem>
            <MenuItem value="news">Novinky</MenuItem>
            <MenuItem value="xml">Produkty (XML)</MenuItem>
          </TextField>
          <TextField
            type="text"
            label="Domovská stránka"
            value={newWebUrl}
            onChange={(e) => setNewWebUrl(e.target.value)}
            fullWidth
            variant="standard"
            InputProps={{ sx: { borderRadius: 1, py: 1 } }}
            sx={{ mb: 2 }}
          />
          <MDTypography variant="body2" mb={1}>
            Výsledná URL:{" "}
            <b>{(newWebUrl.endsWith("/") ? newWebUrl.slice(0, -1) : newWebUrl) + newWebPath}</b>
          </MDTypography>
          {newIngestLoading && (
            <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
              Trénovanie prebieha, prosím čakajte...
            </Alert>
          )}
          {newIngestResult && newIngestResult.status === "success" && (
            <Alert severity="success" sx={{ mt: 1, mb: 2 }}>
              Úspešne: {newIngestResult.num_products || 0} produktov uložených.
            </Alert>
          )}
          {newIngestResult && newIngestResult.status === "error" && (
            <Alert severity="error" sx={{ mt: 1, mb: 2 }}>
              Chyba:{" "}
              {newIngestResult.error ||
                newIngestResult.invalid_entries?.join(", ") ||
                "Neznáma chyba"}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setKnowledgeDialogOpen(false)} color="info">
            Zrušiť
          </MDButton>
          <MDButton
            onClick={handleKnowledgeIngest}
            color="info"
            disabled={newIngestLoading || !newWebUrl}
          >
            {newIngestLoading ? "Trénujem..." : "Trénovať"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Card sx={{ mt: 3, borderLeft: "4px solid", borderColor: "secondary.main" }}>
        <MDBox p={3}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <TuneOutlinedIcon color="secondary" sx={{ mr: 1 }} />
            <MDTypography variant="h6" fontWeight="medium">
              Advanced Settings
            </MDTypography>
          </Box>
          <MDTypography variant="subtitle2" fontWeight="medium" sx={{ mb: 1 }}>
            Default Language
          </MDTypography>
          <MDTypography variant="caption" color="text" sx={{ display: "block", mb: 2 }}>
            The default language for the chatbot if not specified in the request header.
          </MDTypography>
          <ReactSelect
            options={languageOptions}
            value={languageOptions.find((o) => o.value === language) || null}
            onChange={(selectedOption) => setLanguage(selectedOption ? selectedOption.value : "en")}
            styles={customStyles}
            placeholder="Select a language..."
          />

          <MDTypography variant="subtitle2" fontWeight="medium" sx={{ mb: 1, mt: 3 }}>
            Language Model for Answer Generation
          </MDTypography>
          <MDTypography variant="caption" color="text" sx={{ display: "block", mb: 2 }}>
            Choose the AI model that will power your chatbot&apos;s responses. Different models have
            different strengths.
          </MDTypography>
          <ReactSelect
            options={groupedModelOptions}
            value={
              groupedModelOptions
                .flatMap((g) => g.options)
                .find((o) => o.value === modelForAnswer) || null
            }
            onChange={(selectedOption) =>
              setModelForAnswer(selectedOption ? selectedOption.value : "")
            }
            formatOptionLabel={formatOptionLabel}
            styles={customStyles}
            placeholder="Select a model..."
            isClearable
          />

          <MDTypography variant="subtitle2" fontWeight="medium" sx={{ mb: 1, mt: 3 }}>
            Language Model for Intent Detection
          </MDTypography>
          <MDTypography variant="caption" color="text" sx={{ display: "block", mb: 2 }}>
            Model used for understanding the user&apos;s initial query and routing it to the correct
            process.
          </MDTypography>
          <ReactSelect
            options={groupedModelOptions}
            value={
              groupedModelOptions
                .flatMap((g) => g.options)
                .find((o) => o.value === modelForIntent) || null
            }
            onChange={(selectedOption) =>
              setModelForIntent(selectedOption ? selectedOption.value : "")
            }
            formatOptionLabel={formatOptionLabel}
            styles={customStyles}
            placeholder="Select a model (uses Answer model if empty)..."
            isClearable
          />

          <MDTypography variant="subtitle2" fontWeight="medium" sx={{ mb: 1, mt: 3 }}>
            Language Model for Follow-up Questions
          </MDTypography>
          <MDTypography variant="caption" color="text" sx={{ display: "block", mb: 2 }}>
            Model used for generating suggested next questions for the user.
          </MDTypography>
          <ReactSelect
            options={groupedModelOptions}
            value={
              groupedModelOptions
                .flatMap((g) => g.options)
                .find((o) => o.value === modelForFollowup) || null
            }
            onChange={(selectedOption) =>
              setModelForFollowup(selectedOption ? selectedOption.value : "")
            }
            formatOptionLabel={formatOptionLabel}
            styles={customStyles}
            placeholder="Select a model (uses Answer model if empty)..."
            isClearable
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}

ChatbotConfig.propTypes = {
  config: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onConfigChange: PropTypes.func,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
  token: PropTypes.string,
  chatbotID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ChatbotConfig;
